import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const addShoppingFeedAttribute = async ({
  categoryId,
  code,
  name,
  requirement,
  format,
}) => {
  const response = await axiosInstance.post(
    `/mp_categories/${categoryId}/add_shoppingfeed_attribute/`,
    { code, name, requirement, format }
  );
  return response.data;
};

export const useAddShoppingFeedAttribute = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: addShoppingFeedAttribute,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mp-attributes'] });
    },
    retry: 0,
  });

  return {
    addAttribute: mutation.mutate,
    addAttributeAsync: mutation.mutateAsync,
    isAdding: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
};
